// src/Client/Auth/PrivateRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const storedUser = (() => {
    try {
      return JSON.parse(localStorage.getItem("user"));
    } catch {
      return null;
    }
  })();

  if (!storedUser) {
    // Not logged in → redirect to home or login
    return <Navigate to="/" replace />;
  }

  return children;
};

export default PrivateRoute;
